<template lang="pug">
  v-content#pages(:class="$vuetify.theme.dark ? undefined : 'grey lighten-3'")
    v-img(v-if="src" :class="{\
    'v-image--sm': this.$vuetify.breakpoint.smAndDown,\
    'v-image--md': this.$vuetify.breakpoint.mdAndDown\
    }" :src="require(`@/assets/${src || 'clint-mckoy.jpg'}`)" gradient="to top, rgba(0, 0, 0, .2), rgba(0, 0, 0, .2)" min-height="100%" max-height="100vh" cover="")
      v-responsive.d-flex.align-center(:style="styles")
        router-view
    v-responsive.d-flex.align-center(v-else="" :style="styles" min-height="100vh")
      router-view
</template>

<script>
  export default {
    name: 'PagesCoreView',

    data: () => ({
      srcs: {
        '/pages/lock': 'images/background-tender-2.png',
        '/pages/login': 'images/background-tender-2.png',
        '/pages/pricing': 'images/cargo.jpg',
        '/pages/register': 'images/background-tender-2.png',
        '/pages/storefront': '',
      },
    }),

    computed: {
      src () {
        if (this.$route.path.toLowerCase().includes('/pages/register')) {
          return this.srcs['/pages/register']
        }
        return this.srcs[this.$route.path]
      },
      styles () {
        const paddingTop = this.$vuetify.breakpoint.mdAndUp ? 100 : 50
        const paddingBottom = this.$vuetify.breakpoint.mdAndUp ? 50 : 50
        return {
          padding: `${paddingTop}px 0 ${paddingBottom}px 0`,
        }
      },
    },
  }
</script>
